module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    class: {
      'poster-page': _vm.url === '/poster'
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.$store.state.app.is_show1 && _vm.$store.state.app.is_show && _vm.Authorization) ? _c('base-nav', {
    attrs: {
      "isCoolart": _vm.url.indexOf('coolart') === 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.app.is_show) ? _c('base-crumbs', {
    attrs: {
      "crumbs": [],
      "isCoolart": _vm.url.indexOf('coolart') === 1
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "height"
    }
  }, [_c('keep-alive', [(_vm.isUrl(_vm.url)) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.isUrl(_vm.url)) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.app.is_show && _vm.Authorization) ? _c('base-footer') : _vm._e(), _vm._v(" "), (_vm.$store.state.app.indexImg >= 0) ? _c('base-Photobrowser', {
    attrs: {
      "imgData": _vm.$store.state.app.listsImg,
      "param": _vm.$store.state.app.paramImg,
      "index": _vm.$store.state.app.indexImg
    },
    on: {
      "update:index": function($event) {
        return _vm.$set(_vm.$store.state.app, "indexImg", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.app.cart_popup) ? _c('base-add-cart', {
    attrs: {
      "popup": _vm.$store.state.app.cart_popup
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5514b22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1048
// module chunks = 59